// Copyright Epic Games, Inc. All Rights Reserved.

import { IInstallationGroupProgressMessage } from "../../services/EOSHelperAPI";

export const SET_INSTALLATION_PROGRESS = "SET_INSTALLATION_PROGRESS";
export const SET_INSTALLATION_TASK_INFO = "SET_INSTALLATION_TASK_INFO";
export const START_INSTALLATION_PULLING = "START_INSTALLATION_PULLING";
export const STOP_INSTALLATION_PULLING = "STOP_INSTALLATION_PULLING";
export const SET_INSTALLATION_CANCELLING = "SET_INSTALLATION_CANCELLING";
export const CANCEL_INSTALLATION = "CANCEL_INSTALLATION";
export const SET_INSTALLATION_ERROR_CODE = "SET_INSTALLATION_ERROR_CODE";

export interface ISetInstallationProgressAction {
  type: typeof SET_INSTALLATION_PROGRESS;
  payload: {
    progress: IInstallationGroupProgressMessage;
  };
}

export interface ISetInstallationTaskInfoAction {
  type: typeof SET_INSTALLATION_TASK_INFO;
  payload: {
    groupId: string;
  };
}

export interface IStartInstallationPullingAction {
  type: typeof START_INSTALLATION_PULLING;
}

export interface IStopInstallationPullingAction {
  type: typeof STOP_INSTALLATION_PULLING;
}

export interface ISetInstallationCancellingAction {
  type: typeof SET_INSTALLATION_CANCELLING;
  payload: {
    cancellingInstallation: boolean;
  };
}

export interface ICancelInstallationAction {
  type: typeof CANCEL_INSTALLATION;
}

export interface ISetInstallationErrorCodeAction {
  type: typeof SET_INSTALLATION_ERROR_CODE;
  payload: {
    errorCode: string;
  };
}

export type InstallationActionTypes =
  | ISetInstallationProgressAction
  | ISetInstallationTaskInfoAction
  | IStartInstallationPullingAction
  | IStopInstallationPullingAction
  | ISetInstallationCancellingAction
  | ICancelInstallationAction
  | ISetInstallationErrorCodeAction;

export function setInstallationProgress(
  progress: IInstallationGroupProgressMessage
): InstallationActionTypes {
  return {
    type: SET_INSTALLATION_PROGRESS,
    payload: {
      progress,
    },
  };
}

export function setInstallationTaskInfo(
  groupId: string
): InstallationActionTypes {
  return {
    type: SET_INSTALLATION_TASK_INFO,
    payload: {
      groupId,
    },
  };
}

export function startInstallationPulling(): InstallationActionTypes {
  return {
    type: START_INSTALLATION_PULLING,
  };
}

export function stopInstallationPolling(): InstallationActionTypes {
  return {
    type: STOP_INSTALLATION_PULLING,
  };
}

export function cancelInstallation(): InstallationActionTypes {
  return {
    type: CANCEL_INSTALLATION,
  };
}

export function setInstallationCancelling(
  cancellingInstallation: boolean
): InstallationActionTypes {
  return {
    type: SET_INSTALLATION_CANCELLING,
    payload: {
      cancellingInstallation,
    },
  };
}

export function setInstallationErrorCode(
  errorCode: string
): InstallationActionTypes {
  return {
    type: SET_INSTALLATION_ERROR_CODE,
    payload: {
      errorCode,
    },
  };
}
